<template>
	<div>
		<v-card flat class="card-container"
			:class="{ 'radius-bottom': footer, 'radius-top': header }"
		>
			<v-layout wrap>
				<v-flex
					xs12
					class="card-header"
					:style="`color:${$appColors.info}`"
					:class="{ 'footer' : footer }"
					v-if="header || footer">
					<slot name="header"></slot>
				</v-flex>
				<v-flex xs12>
					<slot></slot>
				</v-flex>
			</v-layout>
		</v-card>
	</div>
</template>

<script>
	export default {
		name: 'card-container',
		props: {
			footer: {
				default: false,
				type: Boolean,
			},
			header: {
				default: false,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.card-container {
		background-color: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 9px;

		&.radius-bottom {
			border-radius: 0px;
			border-bottom-left-radius: 9px;
			border-bottom-right-radius: 9px;
			border-top: 0px;
		}

		&.radius-top {
			border-radius: 0px;
			border-top-left-radius: 9px;
			border-top-right-radius: 9px;
		}

		.card-header {
			background-color: map-get($colors, gray-white);
			border-bottom: 1px solid map-get($colors, gray-slider);
			border-top-left-radius: inherit;
			border-top-right-radius: inherit;
			font-family: map-get($fonts, regular);
			font-size: map-get($sizes, medium);

			&.footer {
				border-top-left-radius: 0px;
				border-top-right-radius: 0px;
			}

			div {
				border-bottom-left-radius: inherit;
				border-bottom-right-radius: inherit;
				border-top-left-radius: inherit;
				border-top-right-radius: inherit;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/card-container.vue